export const basicColumns = [[
    {
        "label": "粤",
        "value": "粤"
    },
    {
        "label": "京",
        "value": "京"
    },
    {
        "label": "沪",
        "value": "沪"
    },
    {
        "label": "津",
        "value": "津"
    },
    {
        "label": "冀",
        "value": "冀"
    },
    {
        "label": "晋",
        "value": "晋"
    },
    {
        "label": "蒙",
        "value": "蒙"
    },
    {
        "label": "辽",
        "value": "辽"
    },
    {
        "label": "吉",
        "value": "吉"
    },
    {
        "label": "黑",
        "value": "黑"
    },
    {
        "label": "苏",
        "value": "苏"
    },
    {
        "label": "浙",
        "value": "浙"
    },
    {
        "label": "皖",
        "value": "皖"
    },
    {
        "label": "闽",
        "value": "闽"
    },
    {
        "label": "赣",
        "value": "赣"
    },
    {
        "label": "鲁",
        "value": "鲁"
    },
    {
        "label": "豫",
        "value": "豫"
    },
    {
        "label": "鄂",
        "value": "鄂"
    },
    {
        "label": "湘",
        "value": "湘"
    },
    {
        "label": "桂",
        "value": "桂"
    },
    {
        "label": "琼",
        "value": "琼"
    },
    {
        "label": "渝",
        "value": "渝"
    },
    {
        "label": "川",
        "value": "川"
    },
    {
        "label": "贵",
        "value": "贵"
    },
    {
        "label": "云",
        "value": "云"
    },
    {
        "label": "藏",
        "value": "藏"
    },
    {
        "label": "陕",
        "value": "陕"
    },
    {
        "label": "甘",
        "value": "甘"
    },
    {
        "label": "青",
        "value": "青"
    },
    {
        "label": "宁",
        "value": "宁"
    },
    {
        "label": "新",
        "value": "新"
    }
],[
  {
      "label": "A",
      "value": "A"
  },
  {
      "label": "B",
      "value": "B"
  },
  {
      "label": "C",
      "value": "C"
  },
  {
      "label": "D",
      "value": "D"
  },
  {
      "label": "E",
      "value": "E"
  },
  {
      "label": "F",
      "value": "F"
  },
  {
      "label": "G",
      "value": "G"
  },
  {
      "label": "H",
      "value": "H"
  },
  {
      "label": "I",
      "value": "I"
  },
  {
      "label": "J",
      "value": "J"
  },
  {
      "label": "K",
      "value": "K"
  },
  {
      "label": "L",
      "value": "L"
  },
  {
      "label": "M",
      "value": "M"
  },
  {
      "label": "N",
      "value": "N"
  },
  {
      "label": "O",
      "value": "O"
  },
  {
      "label": "P",
      "value": "P"
  },
  {
      "label": "Q",
      "value": "Q"
  },
  {
      "label": "R",
      "value": "R"
  },
  {
      "label": "S",
      "value": "S"
  },
  {
      "label": "T",
      "value": "T"
  },
  {
      "label": "U",
      "value": "U"
  },
  {
      "label": "V",
      "value": "V"
  },
  {
      "label": "W",
      "value": "W"
  },
  {
      "label": "X",
      "value": "X"
  },
  {
      "label": "Y",
      "value": "Y"
  },
  {
      "label": "Z",
      "value": "Z"
  }
]]

export const mix_board = [
	["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
	["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
	["A", "S", "D", "F", "G", "H", "J", "K", "L"],
	["省份", "Z", "X", "C", "V", "B", "N", "M", "退格"],
]
// 省份缩写键盘
export const province_board = [
  ["京", "沪", "粤", "津", "冀", "晋", "蒙", "辽", "吉", "黑"],
  ["苏", "浙", "皖", "闽", "赣", "鲁", "豫", "鄂", "湘", "桂"],
  ["琼", "渝", "川", "贵", "云", "藏", "陕", "甘", "青", "宁"],
  ["ABC", "新", "使", "领", "警", "学", "港", "澳", "退格"],
]
